const leadInVideos = [...document.querySelectorAll(".video-lead-in")].forEach(
	(el) => {
		const videoType = el.getAttribute("data-video-type");
		const videoId = el.getAttribute("data-video-id");
		const controls = el.getAttribute("data-video-controls");
		const player = el.querySelector(".player");

		let playerVars = {
			playsinline: 1,
			autoplay: 1,
			controls: 0,
			mute: 1,
		};

		if (videoType === "loop") {
			playerVars = Object.assign({}, playerVars, {
				loop: 1,
				playlist: videoId,
			});
		} else if (videoType === "fade") {
			playerVars = Object.assign({}, playerVars, {
				controls,
			});
		}

		function showCTA(el, video) {
			const content = el.querySelector(".lead-in--content");
			const overlay = el.querySelector(".lead-in--overlay"); //el.querySelector(".video-hero--overlay");
			const buttons = el.querySelector(".lead-in--buttons");
			const poster = el.querySelector(".video-hero--poster");
			const iframe = el.querySelector("iframe");
			iframe.classList.add("not-shown");
			[poster, content, overlay, buttons].forEach((el) => {
				if (el == overlay) {
					el.style.opacity = overlay.getAttribute("data-overlay-opacity");
				} else if (el) {
					el.classList.add("shown");
				}
			});
		}

		const vid = new YT.Player(player, {
			videoId,
			playerVars,
			events: {
				onReady: () => {
					const duration = (vid.getDuration() - 0.3) * 1000;
					// // poor man's solution because of YouTube's UI :(
					if (videoType === "loop") {
						setInterval(() => {
							vid.seekTo(0);
							vid.playVideo();
						}, duration);
					}
					vid.playVideo();
				},
				onStateChange({ target, data }) {
					if (data === 0) {
						console.log("Would show CTA");
						showCTA(el);
					}
				},
			},
		});
	},
);
